<template>
    <div class="home">
      <Home/>
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import Home from '@/components/AdminHome.vue'
  
  export default {
    name: 'admin-home-view',
    components: {
      Home
    }
  }
  </script>
  